"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE_COOKIE_NAME = void 0;
exports.languageRedirect = languageRedirect;
const intl_localematcher_1 = require("@formatjs/intl-localematcher");
const negotiator_1 = __importDefault(require("negotiator"));
const server_1 = require("next/server");
const configs_1 = require("../configs");
const helpers_1 = require("../helpers");
const headers_1 = require("next/headers");
const next_i18n_router_1 = require("next-i18n-router");
exports.LOCALE_COOKIE_NAME = "NEXT_LOCALE";
function setLocaleCookie(response, locale) {
    response.cookies.set(exports.LOCALE_COOKIE_NAME, locale, {
        expires: new Date(Date.now() + helpers_1.ONE_MONTH_IN_MS),
        sameSite: "none",
        secure: true,
        httpOnly: true,
    });
}
async function getCookieValue(name) {
    const cookiesStore = await (0, headers_1.cookies)();
    return cookiesStore.get(name);
}
function getLocale(request, defaultLocale, activeLocales, cookieLocale) {
    if (cookieLocale) {
        return cookieLocale;
    }
    const negotiatorHeaders = {};
    request.headers.forEach((value, key) => (negotiatorHeaders[key] = value));
    const locales = activeLocales;
    const languages = new negotiator_1.default({ headers: negotiatorHeaders }).languages(locales);
    const locale = (0, intl_localematcher_1.match)(languages, locales, defaultLocale);
    return locale;
}
async function languageRedirect(request) {
    const COMMON_SITE_CONFIGS = (0, configs_1.getEnvironmentVariable)("COMMON_SITE_CONFIGS");
    const activeLocales = COMMON_SITE_CONFIGS.activeLocales;
    const defaultLocale = COMMON_SITE_CONFIGS.defaultLocale;
    const cookieLocale = await getCookieValue(exports.LOCALE_COOKIE_NAME);
    const pathname = request.nextUrl.pathname;
    const [, lang, ...rest] = pathname.split("/");
    const path = rest.join("/");
    const pathnameIsMissingLocale = activeLocales.every((locale) => !pathname.startsWith(`/${locale}/`) && pathname !== `/${locale}`);
    const i18nConfig = {
        defaultLocale: defaultLocale,
        locales: activeLocales,
        localeDetection: false,
    };
    if (pathnameIsMissingLocale && lang.length === 2) {
        const locale = getLocale(request, defaultLocale, activeLocales, cookieLocale?.value);
        const response = server_1.NextResponse.redirect(new URL(`/${locale}${path.startsWith("/") ? "" : "/"}${path}`, request.url));
        if (cookieLocale?.value && cookieLocale?.value !== locale) {
            setLocaleCookie(response, locale);
        }
        return response;
    }
    return (0, next_i18n_router_1.i18nRouter)(request, i18nConfig);
}
//# sourceMappingURL=languageDetectionV2.js.map